import { useEffect, useState } from 'react';

/** `value`, once it has stopped changing for `ms` (search boxes, live previews). */
export function useDebounced<T>(value: T, ms: number): T {
  const [v, setV] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setV(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return v;
}
